import {Component} from '@angular/core';
import {ParkComponent} from '@app/app/dashboard/parks/park/park.component';

@Component({
  selector: 'card-3',
  templateUrl: './card.3.html'
})

export class Card3Component extends ParkComponent {
  //
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/cards/card.3.component.ts